import { HomeAnnouncementTable } from './HomeAnnouncementTable';
export default HomeAnnouncementTable;
